import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClient } from '../../core/api-client.service';
import { DumbMemberDiscount } from './DTOs/dumb-member-discount';
import { DumbPublicMember } from './DTOs/dumb-public-member';
import { GetMemberDiscountsRequest } from './DTOs/get-company-discounts-search-request';
import { PublicMemberSearchResults } from './DTOs/public-member-search-results';
import { DumbMemberNewsArticle, MemberNewsSearchResult } from './DTOs/dumb-member-news-article';
import { GetMemberNewsSearchRequest } from './DTOs/get-member-news-search-request';
import { MemberNewsArticleDetails } from './DTOs/member-news-article-details';
import { DumbAccountInfo } from './DTOs/dumb-account-info';
import { GetMemberResourcesRequest } from './DTOs/get-member-resources-request';
import { DumbResourcePage } from './DTOs/dumb-resource-page';
import { ResourcePageDetails } from './DTOs/resource-page-details';
import { MakePublicPaymentRequest } from '../public-payments/DTOs/make-public-payment-request';
import { DumbMemberDiscountDtInfo } from './DTOs/dumb-member-discount-dt-info';

@Injectable({
  providedIn: 'root'
})
export class MemberInformationService {


  readonly relativeBase = "member-information/";


  constructor(private http: ApiClient) {

  }

  submitLetterOfIntroduction(req): Observable<boolean[]> {
    return this.http.post(this.relativeBase + "submit-letter", req, false, null, null, true);
  }
  getDumbListOfMembersWithNews(): Observable<DumbPublicMember[]> {
    return this.http.get(this.relativeBase + "list-of-members-with-news", false, true);
  }
  searchNewsArticles(req: GetMemberNewsSearchRequest): Observable<MemberNewsSearchResult> {
    return this.http.post(this.relativeBase + "member-news-search", req, false, null, null, true);
  }
  GetNewsArticleDetails(articleId: string): Observable<MemberNewsArticleDetails> {
    return this.http.get(this.relativeBase + "member-news-article/" + articleId, false, true);
  }
  searchMemberDirectory(req): Observable<PublicMemberSearchResults> {
    return this.http.post(this.relativeBase + "member-directory-search", req, false, null, null, true);
  }
  getMemberDetails(memberId: string): Observable<DumbPublicMember> {
    return this.http.get(this.relativeBase + "get-member-details/" + memberId, false, true);
  }
  searchMemberDiscounts(req: GetMemberDiscountsRequest): Observable<DumbMemberDiscountDtInfo> {
    return this.http.post(this.relativeBase + "member-discounts-search", req, false, null, null, true);
  }
  getMemberDiscountDetails(discountId: number): Observable<DumbMemberDiscount> {
    return this.http.get(this.relativeBase + "member-discount-details/" + discountId, false, true);
  }
  claimMemberDiscount(discountId: number): Observable<boolean> {
    return this.http.post(this.relativeBase + "claim-member-discount/" + discountId, null, false, null, null, true);
  }
  updateAccountInfo(request: DumbAccountInfo): Observable<DumbAccountInfo> {
    return this.http.post(this.relativeBase + "update-account-info", request, false, null, null, true);
  }
  searchMemberResources(req: GetMemberResourcesRequest): Observable<DumbResourcePage[]> {
    return this.http.post(this.relativeBase + "resources-search", req, false, null, null, true);
  }
  GetResourcePageDetails(pageId: string): Observable<ResourcePageDetails> {
    return this.http.get(this.relativeBase + "resource-page/" + pageId, false, true);
  }
  SubmitPublicPayment(request: MakePublicPaymentRequest): Observable<boolean> {
    return this.http.post(this.relativeBase + "submit-public-payment",request, false, null, null, true);
  }

}
